export default "__VITE_ASSET__Cy5Z1mR2__"